import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { InsideLook } from './components/InsideLook';
import { PricingCards } from './components/PricingCards';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const testimonialsSet1 = [{
  name: 'Alejandro M.',
  location: 'Buenos Aires',
  quote: 'Siempre me fascinó la historia antigua, pero los libros que encontraba eran muy densos. Imperio Romano Legendario es exactamente lo que buscaba: visual, entretenido y muy completo. Las ilustraciones son increíbles.',
  rating: 5
}, {
  name: 'Sofía R.',
  location: 'Córdoba',
  quote: 'Lo compré para leerlo con mis hijos y terminamos enganchados todos. El tomo sobre los gladiadores y las batallas es nuestro favorito. Una forma fantástica de descubrir historia en familia.',
  rating: 5
}, {
  name: 'Carlos T.',
  location: 'Rosario',
  quote: 'Como docente de historia, recomiendo muchísimo este material. Logra explicar conceptos complejos del Imperio Romano de una manera muy accesible y visualmente atractiva. Excelente trabajo.',
  rating: 5
}];
const testimonialsSet2 = [{
  name: 'Elena G.',
  location: 'Mendoza',
  quote: 'El atlas visual que viene de bono es una joya. Poder ver los mapas y las rutas de conquista te ayuda a entender mucho mejor cómo se expandió el imperio. Vale cada peso.',
  rating: 5
}, {
  name: 'David L.',
  location: 'La Plata',
  quote: 'Me sorprendió la calidad del contenido. No es solo un resumen de batallas, profundiza en los emperadores, la política y el legado que nos dejaron. Muy recomendable para cualquier curioso.',
  rating: 5
}, {
  name: 'Marta V.',
  location: 'Mar del Plata',
  quote: 'El formato digital es súper cómodo. Lo leo en la tablet mientras viajo. Las infografías se ven espectaculares y la lectura se hace muy amena. Un gran acierto.',
  rating: 5
}];
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark text-white font-body selection:bg-gold/30 selection:text-white" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <Testimonials testimonials={testimonialsSet1} data-id="element-4" />
      <PainPoints data-id="element-5" />
      <InsideLook data-id="element-6" />
      <Tomos data-id="element-7" />
      <CostOfInaction data-id="element-8" />
      <PricingCards data-id="element-9" />
      <Testimonials testimonials={testimonialsSet2} title="LO QUE DICEN NUESTROS LECTORES" data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}